import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { VariableFinancieraService } from './services/variable-financiera.service';
import { IVariableFinanciera, IVariableFinancieraRequest, IVariableFinancieraResponse } from './interfaces/variable-financiera.interface';
import Swal from 'sweetalert2';
import { VariableFinancieraFormComponent } from './variable-financiera-form.component';

@Component({
  selector: 'app-variables-financieras',
  templateUrl: './variables-financieras.component.html',
  providers: [MessageService]
})
export class VariablesFinancierasComponent implements OnInit {
  @ViewChild('dt') table!: Table;
  @ViewChild(VariableFinancieraFormComponent) variableFinancieraFormComponent!: VariableFinancieraFormComponent;

  displayDialog: boolean = false;
  selectedVariableFinanciera: IVariableFinanciera | null = null;
  dataSource: IVariableFinanciera[] = [];
  loading: boolean = false;
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;

  displayedColumns = [
    { field: 'numero_relacion', header: 'N° de Relación', sortable: true },
    { field: 'tipo', header: 'Tipo Variable', sortable: true },
    { field: 'descripcion', header: 'Descripción', sortable: true },
    { field: 'actions', header: 'Acciones', sortable: false }
  ];

  constructor(
    private messageService: MessageService,
    private variableFinancieraService: VariableFinancieraService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    const request: IVariableFinancieraRequest = {
      que: 4,
      tope: "999",
      cmd: "",
      numero_relacion: 0,
      tipo: "",
      descripcion: "",
      formula: "",
      periodicidad: "",
      tipoVariable: ""
    };

    this.variableFinancieraService.getVariablesFinancieras(request).subscribe({
      next: (response: IVariableFinancieraResponse) => {
        if (response.success) {
          this.dataSource = response.data;
          this.totalRecords = response.data.length;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar las variables financieras'
          });
        }
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar las variables financieras'
        });
        console.error('Error:', error);
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  openCreate(): void {
    this.selectedVariableFinanciera = null;
    this.displayDialog = true;
  }

  openUpdate(row: IVariableFinanciera): void {
    this.selectedVariableFinanciera = { ...row };
    this.displayDialog = true;
  }

  openDelete(row: IVariableFinanciera): void {
    Swal.fire({
      title: '¿Está seguro?',
      text: '¿Desea eliminar esta variable financiera?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      iconColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.variableFinancieraService.deleteVariableFinanciera(row.numero_relacion).subscribe({
          next: (response) => {
            if (response.success) {
              this.messageService.add({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Variable financiera eliminada correctamente'
              });
              this.loadData();
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: response.data?.error || 'Error al eliminar la variable financiera'
              });
            }
          },
          error: (error) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Error al eliminar la variable financiera'
            });
          },
          complete: () => {
            this.loading = false;
          }
        });
      }
    });
  }

  onDialogClosed(): void {
    this.selectedVariableFinanciera = null;
    this.displayDialog = false;
    if (this.variableFinancieraFormComponent) {
      this.variableFinancieraFormComponent.clearForm();
    }
  }

  onPage(event: any): void {
    this.first = event.first;
    this.rows = event.rows;
    this.loadData();
  }

  onSave(result: { success: boolean; message: string }): void {
    if (result?.success) {
      this.messageService.add({
        severity: 'success',
        summary: 'Éxito',
        detail: result.message
      });
    }
    this.displayDialog = false;
    this.loadData();
  }
} 